import { api } from '../utils/api';

type AddServicesParams = {
  reservation_id: number;
  services: {
    price: number;
    comment: string;
    quantity: number;
    service_id?: number;
    sub_service_id?: number;
  }[];
};

type AddServiceResponse = {
  reservation_id: number;
  services: {
    price: number;
    comment: string;
    quantity: number;
    service_id: number;
    sub_service_id: number | null;
  }[];
  payment_link: string;
};

export const addServices = async (hotelId: number, params: AddServicesParams) => {
  try {
    const url = `/api/v1/reservation/services/add/${hotelId}/`;

    const bodyRequest = {
      ...params,
    };
    const response = await api.post<AddServiceResponse>(url, bodyRequest);
    return response;
  } catch (error) {
    console.log(error);
  }
};
